export default {
  article: {
    quickAnswerTitle: "Kurze Antwort",
    faqTitle: "Häufig gestellte Fragen",
    relatedTitle: "Verwandte Ressourcen",
    relatedText: "Entdecken Sie weiter organisierte Ressourcen und praktische Guides.",
    ctaTitle: "Bereit, das Spreadsheet zu erkunden?",
    ctaBody: "Gehen Sie zur Hauptwebsite, um Produkte in jeder Kategorie zu durchsuchen.",
    ctaButton: "Spreadsheet erkunden",
    ctaSecondary: "Zurück zur Startseite",
  },
  articles: {
    "what-is-allchinabuy-spreadsheet": {
      category: "Spreadsheet-Guide",
      title: "Was ist das AllChinaBuy-Spreadsheet? Kompletter Guide 2026",
      subtitle:
        "Ein kompletter Überblick, wie das AllChinaBuy-Spreadsheet funktioniert, was es enthält und wie Sie es nutzen, um bessere Kaufentscheidungen zu treffen.",
      updated: "Aktualisiert 2026",
      readTime: "8 Min. Lesezeit",
      quickAnswer:
        "Ein AllChinaBuy-Spreadsheet ist eine organisierte Ressource, die Produkt-Funde, Kategorien, Verkäufer und Kaufhinweise bündelt, damit Sie Ihre Optionen leichter vergleichen können.",
      sections: [
        {
          heading: "Was ist das AllChinaBuy-Spreadsheet?",
          paragraphs: [
            "Ein AllChinaBuy-Spreadsheet ist eine strukturierte Sammlung von Produktressourcen, Kategorielinks und Verkäuferhinweisen. Statt dutzende verstreute Tabs zu öffnen, durchsuchen Sie Schuhe, Kleidung und Zubehör in einer organisierten Ansicht und springen direkt zur passenden Seite der Hauptwebsite.",
            "Der Wert liegt in der Organisation. Ein gut gepflegtes Spreadsheet gruppiert Artikel nach Kategorie, hält Verkäufer-Notizen und QC-Erinnerungen zusammen und beschleunigt den Vergleich vor dem Kauf.",
          ],
        },
        {
          heading: "Warum Menschen ein Spreadsheet für AllChinaBuy nutzen",
          paragraphs: [
            "Einkaufen über eine agentenartige Plattform kann überwältigend wirken, wenn es viele Angebote zu vergleichen gibt. Ein Spreadsheet hält alles an einem Ort: was Ihnen gefiel, der Verkäufer, der geschätzte Preis und die Versandart.",
            "Es reduziert auch Fehler. Wenn Sie Maße, QC-Ergebnisse und Notizen laufend festhalten, bestellen Sie deutlich seltener die falsche Größe oder übersehen ein Warnsignal.",
          ],
        },
        {
          heading: "Was ein gutes Spreadsheet normalerweise enthält",
          paragraphs: [
            "Ein nützliches AllChinaBuy-Spreadsheet bündelt mehrere Arten von Informationen. Häufige Spalten umfassen Kategorie, Produktname, Verkäufer, Preis, QC-Status und die Versand- oder Lieferzeitschätzung.",
            "Kategorielinks sind ein weiterer wichtiger Teil. Gut organisierte Ressourcen verbinden jeden Produkttyp mit einer eigenen Seite, sodass Sie in einem Klick vom Überblick zur Kategorie gelangen.",
          ],
        },
        {
          heading: "So funktioniert das Spreadsheet",
          paragraphs: [
            "Der Ablauf ist einfach und folgt einigen logischen Schritten. Wählen Sie zuerst eine Kategorie, die zu Ihrem Wunsch passt, etwa Schuhe oder Hoodies. Erkunden Sie dann die organisierten Ressourcen dieser Kategorie.",
            "Vergleichen Sie anschließend Produkt- und Verkäuferinformationen nebeneinander. Sobald Sie eine Auswahl haben, prüfen Sie QC-Fotos und Maße und recherchieren Versand- und Lagerdetails.",
          ],
        },
        {
          heading: "Beliebte Kategorien zum Erkunden",
          paragraphs: [
            "Das Spreadsheet deckt viele Kategorien ab: von Schuhen, Hoodies und T-Shirts über Jacken, Hosen, Taschen, Gürtel bis zu Parfums. Jede Kategorie führt zu einer passenden Seite der Hauptwebsite.",
            "In der richtigen Kategorie zu starten spart Zeit. Wenn Sie etwa Zubehör suchen, springen Sie direkt in diesen Bereich statt durch unpassende Angebote zu scrollen.",
          ],
        },
        {
          heading: "QC und Sicherheit: Was Sie vor dem Kauf prüfen sollten",
          paragraphs: [
            "Die Qualitätskontrolle ist einer der nützlichsten Schritte vor dem Versand. Fordern Sie QC-Fotos an und prüfen Sie Maße, Etiketten und Gesamtzustand, und vergleichen Sie sie mit der Beschreibung.",
            "Auch die Verkäuferprüfung zählt. Sehen Sie sich Verkäufer-Historie und Feedback an, lesen Sie die Beschreibung sorgfältig und nutzen Sie nur den offiziellen Bezahlvorgang. Seien Sie bei zu guten Angeboten vorsichtig.",
          ],
        },
        {
          heading: "Versand- und Kostenüberlegungen",
          paragraphs: [
            "Die Versandkosten hängen von Gewicht, Maßen, gewählter Methode und Zielland ab. Schwerere oder größere Artikel kosten meist mehr, und schnellere Methoden haben einen Aufpreis.",
            "Auch Lagerung und QC-Prüfung können Kosten und Zeitplan beeinflussen. Diese Faktoren im Voraus zu verstehen hilft, ein realistisches Budget zu planen.",
          ],
        },
        {
          heading: "Letzte Tipps und wie es weitergeht",
          paragraphs: [
            "Der beste Weg, das AllChinaBuy-Spreadsheet zu nutzen, ist organisiert zu bleiben, sorgfältig zu vergleichen und vor dem Kauf zu prüfen. Halten Sie Wichtiges beim Durchsuchen fest.",
            "Wenn Sie bereit sind, gehen Sie zur Hauptwebsite, um das gesamte Sortiment zu erkunden und Ihren Kauf abzuschließen.",
          ],
        },
      ],
      faqs: [
        {
          q: "Was ist ein AllChinaBuy-Spreadsheet?",
          a: "Eine organisierte Ressource, die Produkt-Funde, Kategorien, Verkäufer und Kaufhinweise bündelt, damit Sie Optionen leichter vergleichen können.",
        },
        {
          q: "Ist AllChinaBuy seriös?",
          a: "AllChinaBuy ist eine agentenartige Plattform, die viele Käufer nutzen. Machen Sie Ihre eigene Prüfung und sehen Sie sich die Verkäufer-Historie an.",
        },
        {
          q: "Was kostet der AllChinaBuy-Versand?",
          a: "Die Kosten hängen von Gewicht, Maßen, Methode und Ziel ab. Schwerere und größere Artikel kosten meist mehr.",
        },
        {
          q: "Wie prüfe ich QC?",
          a: "Fordern Sie QC-Fotos an, prüfen Sie Maße und Etiketten und vergleichen Sie sie mit der Beschreibung, bevor Sie den Versand freigeben.",
        },
      ],
    },

    "allchinabuy-spreadsheet-shoes": {
      category: "Schuhe",
      title: "AllChinaBuy-Spreadsheet Schuhe: kompletter Sneaker- & Schuh-Guide",
      subtitle:
        "So finden, vergleichen und prüfen Sie Schuhe und Sneaker über das AllChinaBuy-Spreadsheet, von Größen und QC bis zum Versand.",
      updated: "Aktualisiert 2026",
      readTime: "7 Min. Lesezeit",
      quickAnswer:
        "Die Kategorie Schuhe im AllChinaBuy-Spreadsheet bündelt Sneaker- und Schuh-Funde, damit Sie Stile, Verkäufer, Preise und QC-Status vor der Bestellung vergleichen können.",
      sections: [
        {
          heading: "Warum Schuhe eine beliebte Kategorie sind",
          paragraphs: [
            "Schuhe gehören zu den meistbesuchten Kategorien im AllChinaBuy-Spreadsheet. Sneaker, Low-Tops, Stiefel und Freizeitschuhe erscheinen zusammen, sodass Sie mehrere Optionen leicht durchsehen können.",
            "Da Größe und Passform zwischen Angeboten variieren, hilft es, Schuh-Referenzen an einem Ort zu halten, um Maße und Verkäufer-Notizen nebeneinander zu vergleichen.",
          ],
        },
        {
          heading: "Was Sie beim Vergleich von Sneakern prüfen sollten",
          paragraphs: [
            "Beginnen Sie mit den Bildern und lesen Sie die Beschreibung sorgfältig. Achten Sie auf klare Bilder von Sohle, Nähten, Logo-Bereich und Details, die Ihnen wichtig sind.",
            "Achten Sie auf Größen. Viele Schuhangebote nutzen asiatische Größen, die von Ihrer lokalen Größe abweichen: Prüfen Sie immer die Größentabelle und die Maße.",
          ],
        },
        {
          heading: "QC-Tipps für Schuhe",
          paragraphs: [
            "Fordern Sie QC-Fotos an, die beide Schuhe nebeneinander, die Außensohlen, Innensohlen und Etiketten zeigen. Symmetrie und Kleberreste früh zu prüfen verhindert, ein Paar mit sichtbaren Fehlern anzunehmen.",
            "Bitten Sie möglichst um ein Foto der Innensohlen-Messung neben einem Lineal. Das ist eine der einfachsten Möglichkeiten, die tatsächliche Länge vor dem Versand zu bestätigen.",
          ],
        },
        {
          heading: "Versand- und Verpackungsüberlegungen",
          paragraphs: [
            "Schuhe werden meist in der Originalbox versendet, sofern Sie nicht um Entfernung bitten. Die Box erhöht Gewicht und Volumen, was die Versandkosten steigern kann.",
            "Entscheiden Sie früh, ob Sie die Box möchten. Schwere Paare und sperrige Verpackung kosten mehr Versand: Diese Abwägungen zu verstehen hilft bei der Budgetplanung.",
          ],
        },
        {
          heading: "Letzte Checkliste vor der Bestellung",
          paragraphs: [
            "Bestätigen Sie die Größe anhand der Tabelle, prüfen Sie QC-Fotos, Verkäufer-Historie und Versandart. Wenige Minuten Prüfung verhindern eine Enttäuschung.",
            "Wenn alles passt, gehen Sie zur Schuh-Seite der Hauptwebsite, um Ihre Bestellung abzuschließen.",
          ],
        },
      ],
      faqs: [
        {
          q: "Wie kenne ich meine Schuhgröße?",
          a: "Prüfen Sie die Größentabelle des Angebots und vergleichen Sie die Innensohlen-Messung mit einem Schuh, den Sie bereits besitzen.",
        },
        {
          q: "Soll ich die Schuhbox behalten?",
          a: "Die Box erhöht Gewicht und Kosten, bietet aber mehr Schutz. Sie zu entfernen senkt die Kosten – wählen Sie nach Ihrer Priorität.",
        },
        {
          q: "Welche QC-Fotos soll ich anfordern?",
          a: "Bitten Sie um beide Schuhe nebeneinander, Außensohlen, Innensohlen und eine Messung neben einem Lineal.",
        },
        {
          q: "Wo kann ich Schuhe durchsehen?",
          a: "Nutzen Sie die Kategorie Schuhe im AllChinaBuy-Spreadsheet, um direkt zur passenden Seite der Hauptwebsite zu gelangen.",
        },
      ],
    },

    "allchinabuy-spreadsheet-clothing": {
      category: "Kleidung",
      title: "AllChinaBuy-Spreadsheet Kleidung: Kauf-Guide für T-Shirts & Outfits",
      subtitle:
        "Ein praktischer Guide, um T-Shirts, Hemden und Alltagskleidung über das AllChinaBuy-Spreadsheet zu finden – mit Tipps zu Größe, Stoff und QC.",
      updated: "Aktualisiert 2026",
      readTime: "7 Min. Lesezeit",
      quickAnswer:
        "Die Kategorie Kleidung organisiert Referenzen zu T-Shirts, Hemden und Outfits, damit Sie Stoff, Größe, Verkäufer-Notizen und QC-Status vor der Bestellung vergleichen können.",
      sections: [
        {
          heading: "Was die Kategorie Kleidung abdeckt",
          paragraphs: [
            "Der Kleidungsbereich des AllChinaBuy-Spreadsheets bündelt T-Shirts, Hemden und andere Alltagskleidung. Das erleichtert das Durchsehen mehrerer Stile und den direkten Sprung zur passenden Seite.",
            "Da Passform und Stoff stark variieren, helfen organisierte Referenzen, Maße und Materialnotizen zu vergleichen, ohne den Überblick zu verlieren.",
          ],
        },
        {
          heading: "So prüfen Sie Stoff und Passform",
          paragraphs: [
            "Lesen Sie die Materialbeschreibung sorgfältig. Baumwolle, Mischungen und Synthetikstoffe fühlen und fallen unterschiedlich: Bestätigen Sie Stoffart und Gewicht vor dem Kauf.",
            "Prüfen Sie immer die Größentabelle und vergleichen Sie die Maße mit einem Kleidungsstück, das Sie besitzen. Schulterbreite, Brust und Länge sind die nützlichsten Zahlen.",
          ],
        },
        {
          heading: "QC-Tipps für T-Shirts und Hemden",
          paragraphs: [
            "Fordern Sie QC-Fotos an, die das Kleidungsstück vorne und hinten, den Kragen, die Nähte und gedruckte oder gestickte Details zeigen. Frühes Prüfen hilft, lose Fäden oder ungleichmäßige Nähte zu erkennen.",
            "Wenn die Farbe wichtig ist, bitten Sie um ein Foto bei natürlichem Licht. Beleuchtung und Bearbeitung können eine Stofffarbe verändern: Ein klares Nahaufnahme-Foto lohnt sich.",
          ],
        },
        {
          heading: "Kauftipps für Alltagskleidung",
          paragraphs: [
            "Mehrere Artikel zusammen zu bestellen kann den Versand bündeln, aber mehr Artikel bedeuten auch mehr Gewicht. Vergleichen Sie die Gesamtkosten vor dem Abschluss.",
            "Notieren Sie Ihre Beobachtungen während des Durchsehens. Größe, Stoff und Verkäufer für jeden Kandidaten aufzuschreiben erleichtert den späteren Vergleich.",
          ],
        },
        {
          heading: "Letzte Checkliste vor der Bestellung",
          paragraphs: [
            "Bestätigen Sie den Stoff, prüfen Sie die Größentabelle, sehen Sie QC-Fotos an und prüfen Sie den Verkäufer. Gehen Sie dann zur Kleidungs-Seite der Hauptwebsite.",
            "Etwas Vorbereitung macht einen großen Unterschied und hilft, Retouren und Größenumtausch zu vermeiden.",
          ],
        },
      ],
      faqs: [
        {
          q: "Wie wähle ich die richtige Kleidergröße?",
          a: "Vergleichen Sie die Maße der Größentabelle mit einem Kleidungsstück, das Sie besitzen – Fokus auf Schulterbreite, Brust und Länge.",
        },
        {
          q: "Welchen Stoff soll ich wählen?",
          a: "Das hängt von Ihren Vorlieben ab. Prüfen Sie die Materialbeschreibung und wählen Sie nach gewünschtem Fall und Gefühl.",
        },
        {
          q: "Wie prüfe ich die Farbgenauigkeit?",
          a: "Bitten Sie um ein QC-Foto bei natürlichem Licht, da Beleuchtung und Bearbeitung eine Stofffarbe verändern können.",
        },
        {
          q: "Kann ich Artikel kombinieren, um zu sparen?",
          a: "Kombinieren kann die Kosten pro Artikel senken, aber mehr Artikel erhöhen das Gesamtgewicht – vergleichen Sie zuerst die Gesamtkosten.",
        },
      ],
    },

    "allchinabuy-spreadsheet-hoodies-jackets": {
      category: "Hoodies & Jacken",
      title: "AllChinaBuy-Spreadsheet Hoodies & Jacken: Outdoor-Guide",
      subtitle:
        "So finden und prüfen Sie Hoodies, Sweatshirts und Jacken über das AllChinaBuy-Spreadsheet, von Material und Passform bis QC und Versand.",
      updated: "Aktualisiert 2026",
      readTime: "7 Min. Lesezeit",
      quickAnswer:
        "Die Kategorie Hoodies und Jacken bündelt Oberbekleidungs-Funde, damit Sie Materialien, Größen, Verkäufer-Notizen und QC-Status vor der Bestellung vergleichen können.",
      sections: [
        {
          heading: "Warum Oberbekleidung besondere Sorgfalt braucht",
          paragraphs: [
            "Hoodies und Jacken sind voluminöser und oft teurer als leichte Kleidung – zusätzliche Prüfung lohnt sich. Das AllChinaBuy-Spreadsheet hält diese Funde organisiert.",
            "Auch die Größen variieren stark zwischen Marken und Verkäufern. Maße und Materialien vor der Bestellung zu prüfen vermeidet eine zu große oder zu kleine Passform.",
          ],
        },
        {
          heading: "Material und Wärme prüfen",
          paragraphs: [
            "Lesen Sie die Stoffbeschreibung, um Gewicht und Wärme zu verstehen. Ein schwerer Fleece-Hoodie fühlt sich ganz anders an als eine dünne leichte Jacke: Bestätigen Sie das Material.",
            "Bei Jacken achten Sie auf Details zu Futter, Füllung und Wasserabweisung, falls wichtig. Diese Eigenschaften beeinflussen Komfort, Gewicht und Leistung.",
          ],
        },
        {
          heading: "QC-Tipps für Hoodies und Jacken",
          paragraphs: [
            "Fordern Sie QC-Fotos an, die Vorderseite, Rückseite, Bündchen, Reißverschluss oder Kordeln und gedruckte Details zeigen. Frühes Prüfen hilft, lose Nähte oder Hardware-Probleme zu erkennen.",
            "Bei gedruckten oder gestickten Motiven bitten Sie um eine Nahaufnahme der Grafik. Das ist der schnellste Weg zu bestätigen, dass der Druck zentriert und scharf ist.",
          ],
        },
        {
          heading: "Versandüberlegungen für Oberbekleidung",
          paragraphs: [
            "Hoodies und Jacken sind schwerer und sperriger als T-Shirts, was meist höhere Versandkosten bedeutet. Dicke Stoffe erhöhen Gewicht und Volumen.",
            "Planen Sie Ihr Budget entsprechend. Schätzungen vor dem Abschluss zu vergleichen vermeidet Überraschungen bei den Gesamtkosten.",
          ],
        },
        {
          heading: "Letzte Checkliste vor der Bestellung",
          paragraphs: [
            "Bestätigen Sie das Material, prüfen Sie die Größentabelle, sehen Sie QC-Fotos von Hardware und Motiven an und prüfen Sie den Verkäufer. Gehen Sie dann zur Hoodies-und-Jacken-Seite.",
            "Ein paar Minuten Prüfung sind bei Oberbekleidung besonders wichtig, wo Kosten und Passform stärker ins Gewicht fallen.",
          ],
        },
      ],
      faqs: [
        {
          q: "Sind Hoodies und Jacken teuer im Versand?",
          a: "Sie sind meist schwerer und sperriger als T-Shirts, daher kostet der Versand oft mehr.",
        },
        {
          q: "Was soll ich auf QC-Fotos prüfen?",
          a: "Konzentrieren Sie sich auf Bündchen, Reißverschluss, Kordeln, Nähte und gedruckte oder gestickte Motive.",
        },
        {
          q: "Wie erkenne ich, ob eine Jacke warm ist?",
          a: "Prüfen Sie die Materialbeschreibung auf Futter, Füllung und Gewicht, die die Wärme bestimmen.",
        },
        {
          q: "Wo durchsuche ich Hoodies und Jacken?",
          a: "Nutzen Sie die Kategorie Hoodies und Jacken im AllChinaBuy-Spreadsheet für den Sprung zur Hauptwebsite.",
        },
      ],
    },

    "allchinabuy-spreadsheet-bags-accessories": {
      category: "Taschen & Zubehör",
      title: "AllChinaBuy-Spreadsheet Taschen & Zubehör: kompletter Guide",
      subtitle:
        "So finden und prüfen Sie Taschen, Uhren, Sonnenbrillen und anderes Zubehör über das AllChinaBuy-Spreadsheet, bevor Sie bestellen.",
      updated: "Aktualisiert 2026",
      readTime: "6 Min. Lesezeit",
      quickAnswer:
        "Die Kategorie Taschen und Zubehör bündelt Taschen, Uhren, Sonnenbrillen und weitere Ergänzungen, damit Sie Stile, Materialien und QC-Status vor der Bestellung vergleichen können.",
      sections: [
        {
          heading: "Was die Kategorie Taschen & Zubehör abdeckt",
          paragraphs: [
            "Der Bereich Taschen und Zubehör des AllChinaBuy-Spreadsheets bündelt Rucksäcke, Totes, Uhren, Sonnenbrillen und weitere Ergänzungen an einem organisierten Ort.",
            "Zubehör wird oft zusammen mit Kleidung oder Schuhen gekauft. Es gebündelt zu halten hilft, ein komplettes Outfit zusammenzustellen und Details nebeneinander zu vergleichen.",
          ],
        },
        {
          heading: "Materialien und Details prüfen",
          paragraphs: [
            "Lesen Sie die Beschreibung, um das Material zu bestätigen – ob echtes Leder, Synthetik, Canvas oder anderes. Das Material beeinflusst Haltbarkeit, Gefühl und Preis.",
            "Bei Taschen prüfen Sie Größe und Fächer. Eine Tasche, die auf Fotos groß wirkt, kann in echt kleiner sein: Prüfen Sie die Maße und vergleichen Sie sie mit etwas, das Sie besitzen.",
          ],
        },
        {
          heading: "QC-Tipps für Zubehör",
          paragraphs: [
            "Fordern Sie QC-Fotos aus mehreren Winkeln an, einschließlich Hardware, Reißverschlüsse, Schnallen und Logos. Kleines Zubehör versteckt Fehler leicht – Nahaufnahmen sind besonders nützlich.",
            "Bei Uhren und Sonnenbrillen bitten Sie um Fotos von Zifferblatt, Band und Markierungen, um Design und Verarbeitung vor dem Versand zu bestätigen.",
          ],
        },
        {
          heading: "Kauf- und Versandtipps",
          paragraphs: [
            "Zubehör ist meist leichter als Kleidung und Schuhe und daher günstiger im Versand. Zerbrechliche Artikel wie Sonnenbrillen benötigen jedoch möglicherweise mehr Verpackung.",
            "Ein paar kleine Zubehörteile in einer Sendung zu kombinieren kann effizient sein. Bestätigen Sie nur, dass jeder Artikel QC besteht, bevor Sie das Paket freigeben.",
          ],
        },
        {
          heading: "Letzte Checkliste vor der Bestellung",
          paragraphs: [
            "Bestätigen Sie das Material, prüfen Sie die Maße, sehen Sie Nahaufnahme-QC-Fotos an und prüfen Sie den Verkäufer. Gehen Sie dann zur Taschen-und-Zubehör-Seite.",
            "Kleine Details zählen bei Zubehör am meisten – etwas mehr Prüfung macht hier einen großen Unterschied für Ihre Zufriedenheit.",
          ],
        },
      ],
      faqs: [
        {
          q: "Wie prüfe ich die echte Größe einer Tasche?",
          a: "Prüfen Sie die angegebenen Maße und vergleichen Sie sie mit einer Tasche, die Sie besitzen, da Fotos täuschen können.",
        },
        {
          q: "Ist Zubehör günstig im Versand?",
          a: "Zubehör ist meist leichter als Kleidung und daher oft günstiger, aber zerbrechliche Artikel brauchen mehr Verpackung.",
        },
        {
          q: "Welche QC-Fotos soll ich anfordern?",
          a: "Bitten Sie um Nahaufnahmen von Hardware, Reißverschlüssen, Schnallen und Logos, um kleine Fehler vor dem Versand zu erkennen.",
        },
        {
          q: "Wo durchsuche ich Zubehör?",
          a: "Nutzen Sie die Kategorie Taschen und Zubehör im AllChinaBuy-Spreadsheet für den Sprung zur Hauptwebsite.",
        },
      ],
    },

    "allchinabuy-qc-guide": {
      category: "QC & Sicherheit",
      title: "AllChinaBuy QC-Guide: Produkte vor dem Versand prüfen",
      subtitle:
        "Ein praktischer Guide zur Qualitätskontrolle beim Kauf über AllChinaBuy, von QC-Fotos und Maßen bis zu Verkäuferprüfung und Warnsignalen.",
      updated: "Aktualisiert 2026",
      readTime: "8 Min. Lesezeit",
      quickAnswer:
        "QC, also Qualitätskontrolle, bedeutet, Fotos, Maße und Verkäuferdetails vor dem Versand zu prüfen, um Probleme früh zu erkennen und ein enttäuschendes Produkt zu vermeiden.",
      sections: [
        {
          heading: "Warum Qualitätskontrolle wichtig ist",
          paragraphs: [
            "Die Qualitätskontrolle ist der Schritt zwischen Bestellung und Versandfreigabe. Wenn Sie zuerst QC-Fotos und Maße prüfen, können Sie Fehler, falsche Größen oder Farben erkennen, bevor das Paket das Lager verlässt.",
            "QC zu überspringen bedeutet, anzunehmen, was ankommt. Wenige Minuten Prüfung sparen die Kosten und den Aufwand einer Retoure oder eines unbrauchbaren Produkts.",
          ],
        },
        {
          heading: "Worauf Sie bei QC-Fotos achten sollten",
          paragraphs: [
            "Gute QC-Fotos zeigen den Artikel aus mehreren Winkeln, inklusive Nahaufnahmen von Nähten, Etiketten, Logos und empfindlichen Stellen. Achten Sie auf lose Fäden, ungleichmäßige Nähte, Kleberreste und Farbunterschiede.",
            "Bei Kleidung und Schuhen bitten Sie um eine Messung neben einem Lineal. Bei Zubehör um Nahaufnahmen der Hardware. Klare Fotos bestätigen schnell die Übereinstimmung mit dem Angebot.",
          ],
        },
        {
          heading: "Maße und Größen prüfen",
          paragraphs: [
            "Vergleichen Sie die gemessenen Maße mit der Größentabelle und einem Artikel, den Sie besitzen. Ein kleiner Unterschied in Länge oder Breite verändert die Passform stark: Verlassen Sie sich nicht nur auf das Etikett.",
            "Bei Schuhen ist die Innensohlen-Länge eine der zuverlässigsten Zahlen. Bitten Sie um ein Foto der Innensohlen-Messung, um die tatsächliche Größe zu bestätigen.",
          ],
        },
        {
          heading: "Verkäufer und Angebote prüfen",
          paragraphs: [
            "Sehen Sie sich Verkäufer-Historie, Feedback und Antwortrate an, bevor Sie sich festlegen. Ein Verkäufer mit klaren Fotos und gutem Ruf ist meist die sicherere Wahl.",
            "Lesen Sie die gesamte Beschreibung. Bestätigen Sie Material, Größe, Farbe und genannte Mängel, und seien Sie bei vagen Angeboten vorsichtig.",
          ],
        },
        {
          heading: "Häufige Warnsignale",
          paragraphs: [
            "Seien Sie vorsichtig bei zu guten Angeboten, Angeboten mit wenigen oder generischen Fotos und Verkäufern, die konkreten Fragen ausweichen.",
            "Schützen Sie Ihre persönlichen Daten und nutzen Sie nur den offiziellen Bezahlvorgang. Bei Zweifeln ist es besser, kurz zu pausieren und zu prüfen, als sich zu beeilen.",
          ],
        },
      ],
      faqs: [
        {
          q: "Was ist QC bei AllChinaBuy?",
          a: "Qualitätskontrolle: Fotos, Maße und Verkäuferdetails vor dem Versand prüfen, um Probleme früh zu erkennen.",
        },
        {
          q: "Wie fordere ich QC-Fotos an?",
          a: "Bitten Sie um klare Fotos aus mehreren Winkeln, inklusive Nahaufnahmen von Nähten, Etiketten und Messungen neben einem Lineal.",
        },
        {
          q: "Was sind häufige QC-Probleme?",
          a: "Lose Fäden, ungleichmäßige Nähte, Kleberreste, Farbunterschiede und falsche Größen gehören zu den häufigsten.",
        },
        {
          q: "Sollte ich immer QC prüfen?",
          a: "Es wird dringend empfohlen. Prüfen vor dem Versand gibt die Chance, Fehler zu erkennen und Enttäuschungen zu vermeiden.",
        },
      ],
    },

    "allchinabuy-shipping-cost": {
      category: "Versand",
      title: "AllChinaBuy Versandkosten: kompletter Preis- & Liefer-Guide",
      subtitle:
        "Verstehen Sie, was die AllChinaBuy-Versandkosten beeinflusst, wie sich Liefermethoden unterscheiden und wie Sie ein realistisches Budget planen.",
      updated: "Aktualisiert 2026",
      readTime: "8 Min. Lesezeit",
      quickAnswer:
        "Die AllChinaBuy-Versandkosten hängen vor allem von Gewicht, Maßen, Methode und Zielland ab, wobei schwerere und schnellere Optionen meist teurer sind.",
      sections: [
        {
          heading: "Was die Versandkosten beeinflusst",
          paragraphs: [
            "Die Versandkosten hängen von einigen Faktoren ab: Gewicht und Maße des Pakets, gewählte Methode und Zielland. Schwerere und größere Artikel kosten meist mehr.",
            "Auch die Methode zählt stark. Schnellere Express-Services haben meist einen deutlichen Aufpreis, während Economy-Optionen günstiger, aber langsamer sind.",
          ],
        },
        {
          heading: "Liefermethoden verstehen",
          paragraphs: [
            "Verschiedene Versandlinien bieten unterschiedliche Balancen aus Geschwindigkeit, Kosten und Zuverlässigkeit. Manche sind schnell, aber teuer, andere günstig, aber langsam mit weniger Tracking.",
            "Wählen Sie eine Methode nach Ihren Prioritäten. Brauchen Sie den Artikel schnell und akzeptieren höhere Kosten, passt Express; sonst kann eine langsamere Linie besser sein.",
          ],
        },
        {
          heading: "Wie Gewicht und Volumen sich summieren",
          paragraphs: [
            "Die Kosten werden oft nach dem höheren von tatsächlichem oder Volumengewicht berechnet, das den Platzbedarf berücksichtigt. Ein sperriger, aber leichter Artikel kann mehr kosten als erwartet.",
            "Schuhe mit Box, dicke Hoodies und gepolsterte Jacken nehmen mehr Platz ein und wiegen mehr – sie kosten mehr Versand als flache, leichte Artikel wie T-Shirts.",
          ],
        },
        {
          heading: "So senken Sie die Versandkosten",
          paragraphs: [
            "Mehrere Artikel in einer Sendung zu bündeln kann die Kosten pro Artikel senken, aber nur bis zu einem Punkt, da Gesamtgewicht und -volumen zählen. Boxen zu entfernen senkt ebenfalls die Kosten.",
            "Planen Sie voraus und vergleichen Sie Schätzungen vor dem Abschluss. Die Abwägungen zwischen Geschwindigkeit, Schutz und Kosten zu verstehen hilft, budgetgerecht zu wählen.",
          ],
        },
        {
          heading: "Lieferzeit und Tracking",
          paragraphs: [
            "Die Lieferzeit variiert nach Methode und Ziel. Manche Methoden liefern in Tagen, andere brauchen Wochen: Passen Sie Ihre Erwartungen an die gewählte Linie an.",
            "Behalten Sie das Tracking im Blick und rechnen Sie mit möglichen Verzögerungen, besonders in Stoßzeiten. Geduld und realistische Erwartungen machen das Warten leichter.",
          ],
        },
      ],
      faqs: [
        {
          q: "Was kostet der AllChinaBuy-Versand?",
          a: "Das hängt von Gewicht, Maßen, Methode und Ziel ab. Schwerere, größere oder schnellere Optionen kosten mehr.",
        },
        {
          q: "Was ist Volumengewicht?",
          a: "Eine Berechnung anhand der Paketgröße. Der Versand kann nach dem höheren von tatsächlichem oder Volumengewicht berechnet werden.",
        },
        {
          q: "Wie senke ich die Versandkosten?",
          a: "Artikel bündeln, unnötige Verpackung entfernen und eine langsamere Methode wählen, wenn Sie warten können.",
        },
        {
          q: "Wie lange dauert die Lieferung?",
          a: "Die Lieferzeit variiert nach Methode und Ziel, von Tagen bei Express bis zu mehreren Wochen bei Economy.",
        },
      ],
    },

    "allchinabuy-warehouse-guide": {
      category: "Lager",
      title: "AllChinaBuy-Lager: Guide zu Lagerung, Prüfung und Bündelung",
      subtitle:
        "Wie das AllChinaBuy-Lager funktioniert, was Lagerung und QC für Ihre Bestellung bedeuten und wie Bündelung die Kosten beeinflusst.",
      updated: "Aktualisiert 2026",
      readTime: "7 Min. Lesezeit",
      quickAnswer:
        "Das AllChinaBuy-Lager ist der Ort, an dem Artikel vor dem Versand gelagert, geprüft und gebündelt werden können, was Kosten und Zeitplan beeinflusst.",
      sections: [
        {
          heading: "Wofür das Lager da ist",
          paragraphs: [
            "Das Lager ist ein Lagerungs- und Verarbeitungsschritt zwischen Kauf und Versand. Artikel können dort aufbewahrt werden, während weitere Käufe eintreffen, um sie in weniger Pakete zu bündeln.",
            "Das ist besonders nützlich, wenn Sie bei mehreren Verkäufern bestellen. Statt jeden Artikel einzeln zu versenden, können Sie sie bündeln, was die Gesamtkosten senken kann.",
          ],
        },
        {
          heading: "Wie die Lagerung funktioniert",
          paragraphs: [
            "Gelagerte Artikel werden meist für einen begrenzten Zeitraum aufbewahrt, danach können Lagergebühren anfallen. Prüfen Sie die aktuelle Richtlinie, um zu wissen, wie lange Sie Artikel lagern können.",
            "Bestellungen so zu planen, dass Artikel etwa gleichzeitig eintreffen, vermeidet lange Lagerzeiten. Je früher Sie bündeln und versenden, desto weniger zahlen Sie.",
          ],
        },
        {
          heading: "QC und Prüfung im Lager",
          paragraphs: [
            "Hier werden auch oft QC-Fotos gemacht. Artikel vor dem Versand zu prüfen gibt die Chance, Fehler, falsche Größen oder Schäden zu erkennen, solange der Artikel leicht umzutauschen ist.",
            "Fordern Sie QC-Fotos für alles an, bei dem Sie unsicher sind. Den Zustand im Lager zu bestätigen ist viel einfacher, als ein Problem nach dem Versand zu lösen.",
          ],
        },
        {
          heading: "Bündelung und ihre Abwägungen",
          paragraphs: [
            "Bündelung kombiniert mehrere Artikel in einem Paket, was die Kosten pro Artikel senkt. Ein einzelnes großes Paket kann aber teuer bleiben, wenn Gesamtgewicht und -volumen hoch sind.",
            "Erwägen Sie, Boxen oder überflüssige Verpackung zu entfernen, um das Volumen zu reduzieren. Die Balance aus Artikelzahl, Verpackung und Methode hilft, die effizienteste Option zu finden.",
          ],
        },
        {
          heading: "Letzte Tipps für das Lager",
          paragraphs: [
            "Verfolgen Sie Ihre Artikel, prüfen Sie Lagerfristen und fordern Sie QC vor der Versandfreigabe an. Organisation vermeidet unerwartete Gebühren und sichert den Empfang in gutem Zustand.",
            "Wenn Sie bereit sind, gehen Sie zur Hauptwebsite, um Ihren Kauf abzuschließen und den Versand zu verwalten.",
          ],
        },
      ],
      faqs: [
        {
          q: "Wofür ist das AllChinaBuy-Lager da?",
          a: "Es ist der Ort, an dem Artikel vor dem Versand gelagert, geprüft und gebündelt werden können.",
        },
        {
          q: "Gibt es Lagergebühren?",
          a: "Die Lagerung ist oft für begrenzte Zeit kostenlos, danach können Gebühren anfallen. Prüfen Sie die aktuelle Richtlinie.",
        },
        {
          q: "Was ist Bündelung?",
          a: "Bündelung kombiniert mehrere Artikel in einem Paket, um die Versandkosten pro Artikel zu senken.",
        },
        {
          q: "Kann ich QC-Fotos im Lager erhalten?",
          a: "Ja, QC-Fotos vor dem Versand anzufordern ist eine übliche Möglichkeit, den Zustand eines Artikels im Lager zu prüfen.",
        },
      ],
    },

    "allchinabuy-coupon-discount": {
      category: "Gutscheine",
      title: "AllChinaBuy-Gutschein & Rabattcode: So funktionieren Ersparnisse",
      subtitle:
        "Eine klare Erklärung, wie AllChinaBuy-Gutscheine und Rabattcodes funktionieren, wo Sie Angebote finden und was Sie vor der Nutzung prüfen sollten.",
      updated: "Aktualisiert 2026",
      readTime: "6 Min. Lesezeit",
      quickAnswer:
        "AllChinaBuy-Gutscheine und Rabattcodes können den Preis einer Bestellung senken, aber Angebote variieren – prüfen Sie die Hauptwebsite und die Bedingungen vor der Nutzung.",
      sections: [
        {
          heading: "Wie Gutscheine und Rabattcodes funktionieren",
          paragraphs: [
            "Gutscheine und Rabattcodes sind Angebote, die den Preis einer Bestellung oder einer Versandgebühr senken können. Sie können für bestimmte Kategorien, Mindestbestellwerte oder Erstkäufe gelten.",
            "Da sich Angebote oft ändern, finden Sie aktuelle Deals am besten auf der Hauptwebsite. Was letzten Monat verfügbar war, ist möglicherweise nicht mehr aktiv – bestätigen Sie es immer.",
          ],
        },
        {
          heading: "Wo Sie Aktionen finden",
          paragraphs: [
            "Aktionen werden meist auf der Hauptwebsite, über offizielle Newsletter oder während saisonaler Sales angekündigt. Diese Kanäle zu verfolgen hilft, Angebote zu entdecken.",
            "Seien Sie bei Codes aus inoffiziellen Quellen vorsichtig. Ein Code aus ungeprüfter Quelle kann abgelaufen oder ungültig sein.",
          ],
        },
        {
          heading: "Was Sie vor der Nutzung eines Codes prüfen sollten",
          paragraphs: [
            "Lesen Sie die Bedingungen sorgfältig. Viele Codes haben einen Mindestbestellwert, ein Ablaufdatum oder Kategoriebeschränkungen: Ein Code, der die Bedingungen nicht erfüllt, funktioniert nicht.",
            "Bestätigen Sie, dass der Rabatt beim Checkout tatsächlich angewendet wird, bevor Sie zahlen. Das Doppelprüfen der Summe verhindert, eine nie angewendete Ersparnis anzunehmen.",
          ],
        },
        {
          heading: "Gutscheine mit anderen Ersparnissen kombinieren",
          paragraphs: [
            "Oft können Sie mehrere Gutscheine nicht auf eine Bestellung stapeln. Prüfen Sie, ob ein Angebot mit Versandaktionen kombiniert werden kann, bevor Sie Ihr Budget planen.",
            "Manchmal kommt die beste Ersparnis aus einem kleinen Rabatt kombiniert mit niedrigeren Versandkosten. Bewerten Sie die Gesamtsumme statt eines einzelnen Gutscheins.",
          ],
        },
        {
          heading: "Letzte Tipps zu Rabatten",
          paragraphs: [
            "Behandeln Sie Gutscheine als nützlichen Bonus, nicht als Garantie. Am zuverlässigsten sparen Sie durch sorgfältigen Vergleich und effiziente Versandplanung.",
            "Wenn Sie bereit sind, gehen Sie zur Hauptwebsite, um Produkte zu durchsuchen und Angebote vor dem Abschluss zu prüfen.",
          ],
        },
      ],
      faqs: [
        {
          q: "Hat AllChinaBuy Gutscheine?",
          a: "Gutscheine und Aktionen variieren. Prüfen Sie die Hauptwebsite für aktuelle Angebote und lesen Sie die Bedingungen vor der Nutzung.",
        },
        {
          q: "Wie nutze ich einen Rabattcode?",
          a: "Geben Sie den Code beim Checkout ein und bestätigen Sie, dass der Rabatt auf die Summe angewendet wird, bevor Sie zahlen.",
        },
        {
          q: "Kann ich mehrere Gutscheine stapeln?",
          a: "Normalerweise nicht. Prüfen Sie die Bedingungen, ob ein Angebot mit anderen kombinierbar ist.",
        },
        {
          q: "Wo finde ich aktuelle Aktionen?",
          a: "Prüfen Sie die Hauptwebsite, offizielle Newsletter und saisonale Sales für die neuesten Angebote.",
        },
      ],
    },

    "allchinabuy-legit-safe": {
      category: "Vertrauen & Sicherheit",
      title: "Ist AllChinaBuy seriös und sicher? Bewertungen, Risiken & Wissenswertes",
      subtitle:
        "Ein ausgewogener Blick darauf, ob AllChinaBuy seriös und sicher ist, wie Sie Verkäufer prüfen, Ihre Daten schützen und Risiken vermeiden.",
      updated: "Aktualisiert 2026",
      readTime: "8 Min. Lesezeit",
      quickAnswer:
        "AllChinaBuy ist eine agentenartige Plattform, die viele Käufer nutzen, aber wie bei jedem Kauf sollten Sie selbst prüfen, die Verkäufer-Historie ansehen und den offiziellen Bezahlvorgang nutzen.",
      sections: [
        {
          heading: "Verstehen, was AllChinaBuy ist",
          paragraphs: [
            "AllChinaBuy ist eine agentenartige Plattform, die Käufern hilft, Produkte zu kaufen und international versenden zu lassen. Viele nutzen sie, um ein breites Sortiment zu durchsuchen.",
            "Als Informationsquelle behauptet diese Website nicht, mit AllChinaBuy verbunden zu sein. Diese Hinweise helfen Ihnen, eigene informierte Entscheidungen zu treffen.",
          ],
        },
        {
          heading: "Seriosität einschätzen",
          paragraphs: [
            "Seriosität beurteilen Sie am besten durch eigene Recherche. Sehen Sie sich Verkäufer-Historie, Feedback und die Klarheit der Angebote an, und seien Sie bei ungewöhnlich günstigen Angeboten vorsichtig.",
            "Prüfen Sie die offizielle Website für aktuelle Bedingungen. Den Bezahlvorgang, die Rückerstattungsrichtlinie und Versandbedingungen vor der Bestellung zu verstehen, reduziert Überraschungen.",
          ],
        },
        {
          heading: "Beim Einkauf sicher bleiben",
          paragraphs: [
            "Nutzen Sie den offiziellen Bezahlvorgang statt ungeprüfter Kanäle. Teilen Sie niemals sensible Daten mit unbekannten Kontakten und halten Sie Ihre Zahlungsdaten sicher.",
            "Seien Sie vorsichtig bei Nachrichten, die Zahlungen außerhalb der Plattform verlangen oder garantierte Ergebnisse versprechen. Betrüger nutzen oft Druck und Dringlichkeit.",
          ],
        },
        {
          heading: "Häufige Risiken und wie Sie sie reduzieren",
          paragraphs: [
            "Häufige Risiken sind Artikel, die nicht dem Angebot entsprechen, längere Lieferzeiten als erwartet und Streitigkeiten mit Verkäufern. Viele lassen sich durch QC-Prüfung und sorgfältiges Lesen reduzieren.",
            "Bewahren Sie Bestellungen und Kommunikation auf. Bei Problemen erleichtert klare Dokumentation die Lösung über die richtigen Kanäle.",
          ],
        },
        {
          heading: "Letzte Ratschläge zu Vertrauen und Sicherheit",
          paragraphs: [
            "Die wichtigste Regel ist, vorsichtig zu bleiben und vor dem Kauf zu prüfen. Ein aufmerksamer Käufer, der Fotos, Verkäufer und Bedingungen prüft, hat deutlich weniger Risiko.",
            "Wenn Sie bereit sind, gehen Sie zur Hauptwebsite, um Produkte zu durchsuchen und den Kauf über den offiziellen Prozess abzuschließen.",
          ],
        },
      ],
      faqs: [
        {
          q: "Ist AllChinaBuy seriös?",
          a: "AllChinaBuy ist eine agentenartige Plattform, die viele Käufer nutzen. Machen Sie Ihre eigene Prüfung und sehen Sie sich die Verkäufer-Historie an.",
        },
        {
          q: "Ist AllChinaBuy sicher?",
          a: "Den offiziellen Bezahlvorgang zu nutzen und persönliche Daten zu schützen sind die besten Wege, sicher zu bleiben.",
        },
        {
          q: "Was sind häufige Risiken?",
          a: "Artikel, die nicht dem Angebot entsprechen, langsamer Versand und Verkäufer-Streitigkeiten – viele durch QC-Prüfung reduzierbar.",
        },
        {
          q: "Wie vermeide ich Betrug?",
          a: "Zahlen Sie nicht außerhalb der Plattform, seien Sie bei zu guten Angeboten vorsichtig und prüfen Sie Verkäufer vor dem Kauf.",
        },
      ],
    },

    "allchinabuy-how-to-use": {
      category: "Anleitung",
      title: "So nutzen Sie das AllChinaBuy-Spreadsheet: Schritt-für-Schritt-Guide",
      subtitle:
        "Eine klare Schritt-für-Schritt-Anleitung zur Nutzung des AllChinaBuy-Spreadsheets, von der Kategorieauswahl bis zum Vergleich der Verkäufer und der Bestellung.",
      updated: "Aktualisiert 2026",
      readTime: "7 Min. Lesezeit",
      quickAnswer:
        "Das AllChinaBuy-Spreadsheet zu nutzen ist einfach: Kategorie wählen, Ressourcen erkunden, Produkte und Verkäufer vergleichen, QC und Versand prüfen, dann zur Hauptwebsite gehen.",
      sections: [
        {
          heading: "Schritt 1: Eine Kategorie wählen",
          paragraphs: [
            "Beginnen Sie mit der Kategorie, die zu Ihrem Wunsch passt, etwa Schuhe, Hoodies, T-Shirts oder Taschen. Die richtige Kategorie zuerst zu wählen hält Ihre Suche fokussiert.",
            "Jede Kategorie im AllChinaBuy-Spreadsheet führt zu einer passenden Seite der Hauptwebsite, sodass Sie direkt zu den Produkten gelangen, die Sie interessieren.",
          ],
        },
        {
          heading: "Schritt 2: Die organisierten Ressourcen erkunden",
          paragraphs: [
            "Sobald Sie in der richtigen Kategorie sind, sehen Sie sich die organisierten Produkt- und Verkäuferreferenzen an. Scannen Sie die Optionen und notieren Sie, was Ihre Aufmerksamkeit weckt.",
            "Eine Liste von Kandidaten während des Durchsehens erleichtert die nächsten Schritte, da Sie dieselben Artikel nicht erneut suchen müssen.",
          ],
        },
        {
          heading: "Schritt 3: Produkte und Verkäufer vergleichen",
          paragraphs: [
            "Vergleichen Sie Ihre ausgewählten Produkte nebeneinander. Sehen Sie sich Fotos, Beschreibungen, Preise und Verkäufer-Historie an, um die Unterschiede zu verstehen.",
            "Ein oberflächlich ähnliches Produkt kann sich in Material, Größe oder Qualität unterscheiden: Sich Zeit zum Vergleichen zu nehmen, verhindert einen enttäuschenden Kauf.",
          ],
        },
        {
          heading: "Schritt 4: QC und Maße prüfen",
          paragraphs: [
            "Bevor Sie sich festlegen, sehen Sie sich QC-Fotos und Maße an. Bestätigen Sie, dass Größe, Material und Zustand dem Angebot entsprechen.",
            "Bei Kleidung und Schuhen vergleichen Sie die Maße mit einem Artikel, den Sie besitzen. Dieser einfache Check ist einer der effektivsten gegen Größenprobleme.",
          ],
        },
        {
          heading: "Schritt 5: Versand recherchieren und fortfahren",
          paragraphs: [
            "Schätzen Sie Versandkosten und Lieferzeit anhand von Gewicht und Ziel. Diese Details zu verstehen hilft, ein realistisches Budget zu planen.",
            "Wenn Sie sicher sind, gehen Sie zur Hauptwebsite, um den Kauf über den offiziellen Prozess abzuschließen. Organisation macht alles flüssiger.",
          ],
        },
      ],
      faqs: [
        {
          q: "Wie starte ich mit dem Spreadsheet?",
          a: "Beginnen Sie mit einer passenden Kategorie und erkunden Sie dann die organisierten Ressourcen.",
        },
        {
          q: "Wie vergleiche ich Produkte?",
          a: "Vergleichen Sie Fotos, Beschreibungen, Preise und Verkäufer-Historie nebeneinander.",
        },
        {
          q: "Wann soll ich QC prüfen?",
          a: "Prüfen Sie QC-Fotos und Maße vor dem Kauf, um Fehler oder Größenprobleme früh zu erkennen.",
        },
        {
          q: "Wo schließe ich meinen Kauf ab?",
          a: "Gehen Sie zur Hauptwebsite, wenn Sie bereit sind, und nutzen Sie den offiziellen Bezahlvorgang.",
        },
      ],
    },
  },
};